import { ReactNode } from "react";
import TopBar from "./TopBar";
import Navigation from "./Navigation";
import Footer from "./Footer";
import WhatsAppChat from "./WhatsAppChat";

interface LayoutProps {
  children: ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="flex flex-col min-h-screen bg-background text-foreground">
      {/* Top Bar */}
      <TopBar />

      {/* Navigation */}
      <Navigation />

      {/* Main Content Area */}
      <main className="flex-grow">
        {children}
      </main>

      {/* Footer (Sticky — appears only when scrolled to bottom) */}
      <Footer />

      {/* Floating WhatsApp Chat Button */}
      <WhatsAppChat />

      
    </div>
  );
};

export default Layout;
